export default "__VITE_ASSET__PE5LonIP__"